import orderBy from 'lodash/orderBy';
import { getManagedEpisodesById, getManagedEpisodesBySoundcast } from './managed';

export const getSoundcastEpisodes = (state, soundcastId) => {
  const bySoundcast = getManagedEpisodesBySoundcast(state);
  const byId = getManagedEpisodesById(state);
  return orderBy(
    bySoundcast[soundcastId].map(episodeId => byId[episodeId]),
    'index',
    'desc'
  );
};
